import React from 'react';

const toneCls = {
  cyan: '',
  amber: 'nx-tl-dot--amber',
  red: 'nx-tl-dot--red',
  lime: 'nx-tl-dot--lime',
};

export function NxTimelineItem({ tone = 'cyan', when, title, children }) {
  return (
    <div className="nx-tl-item">
      <span className={`nx-tl-dot ${toneCls[tone] || ''}`} />
      <div className="flex flex-wrap items-baseline gap-x-3">
        <span className="nx-mono" style={{ fontSize: 10, letterSpacing: '0.16em', color: 'var(--nx-ink-dim)', textTransform: 'uppercase' }}>
          {when}
        </span>
        <span className="nx-display" style={{ fontSize: 13, color: 'var(--nx-ink)' }}>
          {title}
        </span>
      </div>
      {children && (
        <p className="mt-1" style={{ color: 'var(--nx-ink-soft)', fontSize: 13, lineHeight: 1.5 }}>
          {children}
        </p>
      )}
    </div>
  );
}

export function NxTimeline({ children }) {
  return <div className="nx-timeline">{children}</div>;
}
